import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

import AuthorsList from '../AuthorsList';

const { composeRelatedAuthorLinkClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

const handleClick = () => {
  sendAnalyticsEvents(
    composeRelatedAuthorLinkClickEvent({
      containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_EXPLORE_FURTHER
    })
  );
};

export default function RelatedAuthors({ relatedAuthors }) {
  if (relatedAuthors.size === 0) return null;

  return (
    <div className="cp-related-authors">
      <div className="related-authors-heading">
        <FormattedMessage tagName="h3" id="related_authors" />
      </div>
      <AuthorsList authors={relatedAuthors} handleClick={handleClick} />
    </div>
  );
}

RelatedAuthors.propTypes = {
  relatedAuthors: ImmutablePropTypes.list.isRequired
};
